var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKlydoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 111,
    viewBox: "0 0 69 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Klydo Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.95581C0 3.58345 2.73384 0.849609 6.10619 0.849609H62.8938C66.2662 0.849609 69 3.58345 69 6.9558V104.044C69 107.417 66.2662 110.15 62.8938 110.15H6.10619C2.73383 110.15 0 107.417 0 104.044V6.95581ZM64.115 35.0443C64.115 51.2316 50.9926 64.354 34.8053 64.354C18.618 64.354 5.49558 51.2316 5.49558 35.0443C5.49558 18.857 18.618 5.73457 34.8053 5.73457C50.9926 5.73457 64.115 18.857 64.115 35.0443ZM34.8053 104.655C42.899 104.655 49.4602 98.0937 49.4602 90.0001C49.4602 81.9064 42.899 75.3452 34.8053 75.3452C26.7116 75.3452 20.1504 81.9064 20.1504 90.0001C20.1504 98.0937 26.7116 104.655 34.8053 104.655Z",
    fill: "white",
    fillOpacity: 0.12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlydoIcon);
export default __webpack_public_path__ + "static/media/KlydoIcon.e357c18982aa430b1bd496ca71d945cd.svg";
export { ForwardRef as ReactComponent };